<template lang="pug">
  #customer-info
    #tmp-container.mt-3.d-flex.mx-auto
      b-card.w-100.mt-1
        input-customer-data(v-model="value")
        b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", @click="backPage()")
          .float-right.search_message.ml-1.font-weight-bold 戻る
          b-icon.float-left.next-icon(icon="arrow-left-circle")
      price-board(v-model="value")
</template>

<script>
import InputCustomerData from "@/components/firstOrder/InputCustomerData";
import PriceBoard from "@/components/PriceBoard";

export default {
  name: "CustomerInfo",
  props: {
    value: { type: Object, required: false }
  },
  components: {
    PriceBoard,
    InputCustomerData
  },
  methods: {
    backPage() {
      // サービス内容入力画面へ遷移
      this.$router.push({
        name: "InputServiceContents",
        query: {
          token: this.value.token
        }
      })
    },
  }
}
</script>

<style scoped>
.stepper-style {
  width: 900px;
  background-color: #c0c0c0;
  color: #ffffff;
}
.active-step {
  background-color: #4169e1;
}
.next-icon {
  margin-top: 2px;
}
</style>